import * as React from "react";

function SvgArrow1Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 13.131 8.756" {...props}><path stroke="currentColor" strokeWidth={1.2} d="M13.13 4.732h-11M5.131 1.131l-4 4M5.13 8.331l-4-4" /></svg>;
}

export default SvgArrow1Icon;